export const NIEUWE_TOCHT_BESTAANDE_ORGANISATOR = "NIEUWE_TOCHT_BESTAANDE_ORGANISATOR";
export const WIJZIG_ORGANISATOR = "WIJZIG_ORGANISATOR";
export const WIJZIG_TOCHT = "WIJZIG_TOCHT";
export const WIJZIG_LUS = "WIJZIG_LUS";
export const WIJZIG_TOELATINGEN = "WIJZIG_TOELATINGEN";
export const WIJZIG_PUBLICATIE = "WIJZIG_PUBLICATIE";